import { render, staticRenderFns } from "./u-pagination-text-circle.vue?vue&type=template&id=d662e692&scoped=true"
import script from "./u-pagination-text-circle.vue?vue&type=script&lang=js"
export * from "./u-pagination-text-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d662e692",
  null
  
)

export default component.exports